import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import CarrierLayout from './components/CarrierPortal/CarrierLayout';
import CarrierLoadboard from './components/CarrierPortal/Loadboard';
import { useEffect, useState } from 'react';
import LoginPage from './components/Login/Loginpage';
import Signup from './components/Signup/Signup';
import CreatePassword from './components/Signup/CreatePassword';
import VerifyOtp from './components/Signup/VerifyOtp';
import VerifyOtp2 from './components/Login/VerifyOtp2';
import Subscription from './components/Subscription/Subscriptionplans';
import ResetPassword from './components/Login/ResetPassword';
import CompanyProfile from './components/CompanyProfile/CompanyProfile';
import Dashboard from './components/adminlayout/Dashboard';
import TeamManagement from './components/TeamManagement/TeamManagement';
// import AddMember from './components/TeamManagement/AddMember';
import AdminLayout from './components/adminlayout/AdminLayout';
import OrderContainer from './components/adminlayout/OrderContainer';
import Dispatch from './components/adminlayout/Dispatch';
import ProofOfDelivery from './components/adminlayout/ProofOfDelivery';
import Invoice from './components/adminlayout/Invoice';
import Reports from './components/adminlayout/Reports';
import Documents from './components/adminlayout/Documents';
import Drivers from './components/adminlayout/Drivers';
import CompanyProfiles from './components/adminlayout/CompanyProfiles';
import Notification from './components/adminlayout/Notification';
import Messages from './components/adminlayout/Messages';
import Landing from './components/Landingpage/Landingpage';
import Contact from './components/Landingpage/Contact';
import Cookies from './components/Landingpage/Cookies';
import Terms from './components/Landingpage/Terms';
import Privacy from './components/Landingpage/Privacy';
import FAQ from './components/Landingpage/FAQ';
import ThanksPackage from './components/Subscription/Thankspackage';
import Failed from './components/Subscription/Failed';
import { IncomingCallPopup } from './components/IncomingCall';
import ContactPage from './components/Landingpage/ContactPage';
import CreateCompanyProfile from './components/CompanyProfile/CompanyProfile';
import { ToastContainer } from 'react-toastify';
import AboutUs from './components/Landingpage/AboutUs';
import ClientManagement from './components/adminlayout/ClientManagement';
import IncidentReports from './components/adminlayout/IncidentReports';
import ThanksAiPackage from './components/Subscription/ThanksAiPackage';
import FailedAiPackage from './components/Subscription/FailedAiPackage';
import TotalPendingContainer from './components/adminlayout/TotalPendingContainer';
import TotalTransitList from './components/adminlayout/TotalTransitList';
import TotalDelivered from './components/adminlayout/TotalDelivered';
import LinkDataPage from './components/adminlayout/LinkDataPage';
import PaymentSuccess from './components/adminlayout/PaymentSuccess';
import PaymentFailed from './components/adminlayout/PaymentFailed';
import { generateFCMToken } from './components/utils/utils';
import { updateCompanyDetails } from './ApiController/ApiService';
import ExportContainer from './components/adminlayout/ExportContainer';
import LoadsContainer from './components/adminlayout/LoadsContainer';
import InvoiceByClient from './Payment/InvoiceByClient';
import HeroSection from './components/Landingpage/Landingpage';

// ✅ ProtectedRoute sirf login check karega
const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (isAuthenticated) {
    return children;
  }
  return <Navigate to="/login" replace />;
};

function App() {
  const { pathname } = useLocation();
  const authToken = localStorage.getItem("accessToken"); // ✅ using token instead of undefined userId

const [fcbTokenData,setFcbToken] =useState(null)
// 1️⃣ Generate FCM token once
useEffect(() => {
  const getToken = async () => {
    const token = await generateFCMToken();

    if (token) {
      console.log("FCM token generated:", token);
      setFcbToken(token);
    }
  };

  getToken();
}, []);


// 2️⃣ Call API only when BOTH tokens are available
useEffect(() => {
  if (!fcbTokenData || !authToken) {
    console.log("Waiting for authToken or FCM token...");
    return;
  }

  const updateToken = async () => {
    try {
      await updateCompanyDetails({ fcmToken: fcbTokenData });

      console.log("✅ FCM token updated in backend");
    } catch (err) {
      console.error("Error updating FCM token:", err);
    }
  };

  updateToken();

}, [fcbTokenData, authToken]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
          <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />

                <Route path="/" element={<HeroSection  />} />

                <Route path="/singup/create-profile" element={<CreateCompanyProfile />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/createpassword" element={<CreatePassword />} />
        <Route path="/verifyotp" element={<VerifyOtp />} />
        <Route path="/verifyotp2" element={<VerifyOtp2 />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
                <Route path="/about-us" element={<AboutUs />} />

        <Route path="/faq" element={<FAQ />} />
        <Route path="/invoice-by-client" element={<InvoiceByClient />} />

        {/* Subscription-related Routes */}
        <Route path="/priceplans" element={<Subscription />} />
        <Route path="/thankspackage/:id" element={<ThanksPackage />} />
        <Route path="/failed/:id" element={<Failed />} />
        <Route path="/thanksAipackage/:id" element={<ThanksAiPackage />} />
        <Route path="/failedAipackage/:id" element={<FailedAiPackage />} />
        <Route path="/thanksInvoice/:id" element={<PaymentSuccess />} />
        <Route path="/failedInvoice/:id" element={<PaymentFailed />} />

        {/* Protected Routes (login required) */}
        <Route
          path="/companyprofile"
          element={
            <ProtectedRoute isAuthenticated={!!authToken}>
              <CompanyProfile />
            </ProtectedRoute>
          }
        />





        <Route
          path="/team-management"
          element={
            <ProtectedRoute isAuthenticated={!!authToken}>
              <TeamManagement />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/add-member"
          element={
            <ProtectedRoute isAuthenticated={!!authToken}>
              <AddMember />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute isAuthenticated={!!authToken}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="home" replace />} />
          
          <Route path="home" element={<Dashboard />} />
          <Route path="/dashboard/client-management" element={<ClientManagement />} />

          <Route path="order-container" element={<OrderContainer />} />
          <Route path="dispatch" element={<Dispatch />} />
          <Route path="proof-of-delivery" element={<ProofOfDelivery />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="reports" element={<Reports />} />
          <Route path="documents" element={<Documents />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="company-profile" element={<CompanyProfiles />} />
          <Route path="notification" element={<Notification />} />
          <Route path="messages" element={<Messages />} />
          <Route path="total-pending" element={<TotalPendingContainer />} />
          <Route path="total-transit-list" element={<TotalTransitList />} />
          <Route path="total-delivered" element={<TotalDelivered />} />
          <Route path="link-data" element={<LinkDataPage />} />

          <Route path="export-container" element={<ExportContainer  />} />
          <Route path="loads" element={<LoadsContainer />} />

          
        <Route
          path="/dashboard/incident-report"
          element={
            <ProtectedRoute isAuthenticated={!!authToken}>
              <IncidentReports />
            </ProtectedRoute>
          }
        />

        </Route>

        {/* Carrier Portal Routes */}
        <Route
          path="/carrier"
          element={
            <ProtectedRoute isAuthenticated={!!authToken}>
              <CarrierLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="loads" replace />} />
          <Route path="loads" element={<CarrierLoadboard />} />
        </Route>
      </Routes>

    </>
  );
}

export default App;
